import utils from '@eitje/utils'
import _ from 'lodash'
import {Tooltip} from '../tooltip'
import {InfoPopout} from './components'
import {toString, getWeight, useTruncation} from './helpers'
import './styles/index.less'
import {useMergedRefs} from '../layout/helpers'
import {withInfoIconMessage} from '../info_icon_message'

export * from './components'

const TextComponent = props => {
	return <BaseText type="text" {...props} />
}

const TitleComponent = props => {
	const bold = !props.semiBold && !props.weight
	return <BaseText type="title" bold={bold} {...props} />
}

export const Text = withInfoIconMessage(TextComponent)
export const Title = withInfoIconMessage(TitleComponent)

export const BaseText = ({ref, ...props}) => {
	let {
		children,
		className,
		type, // 'text' or 'title'
		t = {},
		mdT,
		style,

		// Font
		fontSize,
		large,
		small,
		mini,

		// Weight
		weight,
		semiBold,
		bold,

		// Decoration
		color,
		underline,
		italic,
		strikethrough,
		noTextSelect,
		center,
		hyperlink,

		// Truncate
		truncate,
		hideTruncateTooltip,

		// Extra's
		onClick,
		countSuffix,

		// Popout & tooltip
		popoutTitle,
		popoutBody,
	} = props

	const text = toString({children, t, mdT, countSuffix, debug: false})
	const {ref: innerRef, isTruncated} = useTruncation({text, truncate})
	const mergedRef = useMergedRefs(innerRef, ref)

	// If, for whatever reason, the text is empty, don't render it, to save unnecessary DOM nodes.
	if (_.isEmpty(text)) return null

	className = utils.makeCns(
		className,
		type,
		color,
		getWeight(props),
		truncate && 'truncate',
		underline && 'underline',
		italic && 'italic',
		strikethrough && 'strikethrough',
		center && 'text-center',
		onClick && 'pointer',
		noTextSelect && 'no-text-select',
		hyperlink && 'hyperlink',
		large && 'large',
		small && 'small',
		mini && 'mini',
	)

	style = {
		maxWidth: _.isNumber(truncate) && truncate + 'px',
		fontSize,
		...style,
	}

	const element = (
		<p ref={mergedRef} className={className} style={style} onClick={onClick}>
			{text}
		</p>
	)

	const showPopout = popoutTitle || popoutBody
	const showTruncateTooltip = isTruncated && !hideTruncateTooltip
	const showPlainText = !showPopout && !showTruncateTooltip

	if (showPlainText) return element

	if (showTruncateTooltip) return <Tooltip trigger={element} text={text} />

	// TO DO: Refactor below components once we have Thijs' new popout component.
	const truncateProps = {text, element, showTruncateTooltip}
	if (showPopout) return <InfoPopout {...truncateProps} {...props} />
}
